import React from 'react'
import {Link} from 'react-scroll' 
import avatar from '../Images/avatar.png';

function Footer() {
  return (
    <div className="w-full h-1/4 bg-slate-700 text-white m-auto">
    <div className='flex p-6'>
    <img src={avatar} alt="profile" className='rounded-full border-black border-2 bg-slate-300' />
      <h1 className='mt-auto mx-3 text-xl'> © Harsh Tiwari</h1>  
       <ul className='ml-auto m-auto space-x-3 flex'>
        <li className='hover:animate-bounce'><a href='https://www.linkedin.com/in/harsh-tiwari-b3696a22a/'>LinkedIn</a></li>
        <li className='hover:animate-bounce'><a href='https://github.com/Harsh21it'>Github</a></li>
        <li className='hover:animate-bounce'><a href="https://instagram.com/harshtiwari2510?igshid=NTc4MTlwNjQ2Yq==">Instagram</a></li>
        <li className='hover:animate-bounce'><a href='https://leetcode.com/harshwarlord2510/'>LeetCode</a></li>
        <li className='hover:animate-bounce'><a href='https://www.codechef.com/users/harshwarlord25'>Codechef</a></li>
        <li className='hover:animate-bounce'><a href='https://codeforces.com/profile/harshwarlord2510'>Codeforces</a></li>
       </ul>
      <div className='flex flex-col m-auto text-left'>
      <h1 className=''>Contact Me</h1>
      <h1 className=''>Mail Me: Harshtiwari2510@gmail.com</h1>
      <h1 className=''>Whatsapp : 93548XXXXX </h1>
      <h1 className='cursor-pointer'><Link to="home" spy={true} smooth={true} offset={-100} duration={500}>Go to Top</Link></h1>
      </div>
    </div>
    </div>
  )
}

export default Footer;
